import React from 'react';
import { motion } from 'framer-motion';
import PrivacyPolicy from '../components/UI/PrivacyPolicy';
import SEOHead from '../components/UI/SEOHead';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEOHead
        title="Política de Privacidad"
        description="Política de Privacidad de Ruray Digital. Cómo recopilamos, usamos y protegemos tu información y datos de Meta/WhatsApp Business."
        path="/politica-privacidad"
        noindex={false}
      />
      <PrivacyPolicy />
    </motion.div>
  );
};

export default PrivacyPolicyPage;
